var form = (function () {
    "use strict";

    $('.youtubeteaser').each(function () {
        var teaser = $(this),
            playBtn = $(".play-button", teaser),
            previewimg = $("img", teaser),
            stopBtn = $('<button>', {
                'html': '&times;',
                'class': 'stop-button'
            }),
			video = $('<iframe>', {
			    'class': 'video',
			    'allowfullscreen': '',
			    'frameborder': '0',
			    'width': teaser.width(),
			    'height': teaser.height(),
			    'src': teaser.data("youtube") + "?autoplay=1&showinfo=0&color=white&controls=1"
			});

        playBtn.click(function (e) {
            e.preventDefault();
            playBtn.fadeOut(250);
            previewimg.fadeOut(250, function () {
                teaser.append(video, stopBtn);
                video.load(function () {
                    video.css('visibility', 'visible');
                    stopBtn.fadeIn(250);
                });
            });
        });

        stopBtn.click(function (e) {
            e.preventDefault();
            video.remove();
            stopBtn.remove();
            previewimg.fadeIn(250);
            playBtn.fadeIn(250);
        });
    });
})();